
import React, {Component} from 'react'
import {Modal, ModalBody} from 'reactstrap';
import { TabPanel } from "react-headless-tabs";
import DisplaySettingsView from './DisplaySettingsView'
import ControlSettingsView from './ControlSettingsView'
import SoundSettingsView from './SoundSettingsView'
import PrinterSettingsView from './PrinterSettingsView'

var stateManager = require('../../utils/state/stateManager.js');
const translator = require('../../utils/translator/translator.js');
var navigationDialogueAction = require('../../utils/state/actions/views/navigationDialogue/navigationDialogueAction');

class SettingsView extends Component 
{

    constructor(props)
    {
        super(props);

        this.state = {};
        this.state.tabs = [];
        this.state.tabs.push("display");
        this.state.tabs.push("sound");
        this.state.tabs.push("print");
        this.state.tabs.push("control");
        this.state.selectedTab = this.state.tabs[0];
        this.state.cachedData = {};
        
    }

    render()
    {
        return(<Modal isOpen={true} centered animation={false} fade={false} style={{minWidth:'80vw', maxWidth:'80vw'}}
                      toggle={()=>
                                {
                                    stateManager.getStore().dispatch(navigationDialogueAction.createAction(null));
                                }} >
                    <ModalBody>
                        <div>
                            <nav style={{
                                position: "relative",
                                border: "1px solid #05149e"
                                }}>

                                    <div
                                        style={{
                                            display: "flex"
                                        }}
                                    >
                                    {this.state.tabs.map((item) => {
                                        return (
                                        <span
                                            style={{
                                            flexGrow: 1,
                                            display: "block",
                                            padding: "1rem",
                                            textDecoration: "none",
                                            textAlign: 'center',
                                            color: this.state.selectedTab === item ? "white" : "var(--colors-primary)",
                                            background: this.state.selectedTab === item ? "var(--colors-primary)" : "var(--background-color)",
                                            borderRight: '1px solid var(--colors-primary)',
                                            cursor:'pointer'
                                            }}
                                            onClick={()=>
                                            {
                                                this.state.selectedTab = item;
                                                this.setState({});
                                            }}
                                        >
                                            {translator.getLabel(item)}
                                        </span>
                                        );
                                    })}
                                    </div>
                            </nav>
                            <TabPanel>
                                {this.getTabPanel()}
                            </TabPanel>
                        </div>
                    </ModalBody>
                </Modal>);
    }

    getTabPanel()
    {
        if (this.state.selectedTab == "display")
            return <div style={{paddingTop:'30px', paddingBottom:'30px', paddingLeft:'20px', paddingRight:'20px', height:'70vh', overflowY:'auto'}}>
                        <DisplaySettingsView/>
                    </div>

        if (this.state.selectedTab == "control")
            return <div style={{paddingTop:'30px', paddingBottom:'30px', paddingLeft:'20px', paddingRight:'20px', height:'70vh', overflowY:'auto'}}>
                        <ControlSettingsView/>
                    </div>

        if (this.state.selectedTab == "sound")
            return <div style={{paddingTop:'30px', paddingBottom:'30px', paddingLeft:'20px', paddingRight:'20px', height:'70vh', overflowY:'auto'}}>
                    <SoundSettingsView/>
                </div>

        if (this.state.selectedTab == "print")
            return <div style={{paddingTop:'30px', paddingBottom:'30px', paddingLeft:'20px', paddingRight:'20px', height:'70vh', overflowY:'auto'}}>
                    <PrinterSettingsView cachedData={this.state.cachedData}/>
                </div>
    }
}

export default SettingsView;